import { useCallback } from 'react';
import { usePartnerDataClient } from '../api/use-partner-data-client';
import { useAsyncResource } from './use-async-resource';

export interface UseDataProvidersReturn {
  dataProviders: string[];
  isLoading: boolean;
  hasError: boolean;
  refetch: () => void;
}

const EMPTY_DATA_PROVIDERS: string[] = [];

/**
 * Fetches the list of known data provider names, used to populate filter
 * dropdowns on the ingestions and configurations pages.
 */
export const useDataProviders = (): UseDataProvidersReturn => {
  const client = usePartnerDataClient();

  const fetchDataProviders = useCallback(
    () => client.getDataProviders(),
    [client],
  );

  const { data, isLoading, hasError, refetch } = useAsyncResource(
    fetchDataProviders,
    EMPTY_DATA_PROVIDERS,
  );

  return { dataProviders: data, isLoading, hasError, refetch };
};
